import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { createContext, useEffect, useRef, useState } from "react";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RecaptchaV3Context = /*#__PURE__*/createContext();
RecaptchaV3Context.displayName = "RecaptchaV3Context";
export function RecaptchaV3Provider(_ref) {
  let {
    children
  } = _ref;
  const {
    0: recaptchaV3Badge,
    1: setRecaptchaV3Badge
  } = useState(false);
  const recaptchaV3BadgeRef = useRef(null);
  const showRecaptchaV3Badge = () => {
    setRecaptchaV3Badge(true);
  };
  const hideRecaptchaV3Badge = () => {
    setRecaptchaV3Badge(false);
  };
  const contextValue = {
    recaptchaV3Badge,
    showRecaptchaV3Badge,
    hideRecaptchaV3Badge
  };
  useEffect(() => {
    if (recaptchaV3Badge) {
      recaptchaV3BadgeRef.current.style.visibility = "visible";
      recaptchaV3BadgeRef.current.style.position = "relative";
      recaptchaV3BadgeRef.current.style.zIndex = "9999";
    } else {
      recaptchaV3BadgeRef.current.style.visibility = "hidden";
    }
  }, [recaptchaV3Badge]);
  return /*#__PURE__*/_jsxs(RecaptchaV3Context.Provider, {
    value: contextValue,
    children: [/*#__PURE__*/_jsx("div", {
      id: "recaptchaV3Badge",
      ref: recaptchaV3BadgeRef
    }), /*#__PURE__*/_jsx(GoogleReCaptchaProvider, {
      reCaptchaKey: config.reCAPTCHASiteKey.v3,
      language: "ja",
      useEnterprise: true,
      container: {
        element: "recaptchaV3Badge",
        parameters: {
          badge: "bottomright",
          theme: "light"
        }
      },
      children: children
    })]
  });
}